import FeatureFlagDataTable from 'components/FeatureFlagDataTable'
import { FilterMatchMode } from 'primereact/api'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { DataTable, DataTableValue } from 'primereact/datatable'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ToastContent, toast } from 'react-toastify'
import { handleLoader } from 'redux/counterSlice';
import { getUserFeatureFlagData, updateFeatureFlagData } from 'services/featureFlagService'

const FlagInfo = ({ email }: { email: string }) => {

    const {
        register,
        handleSubmit,
        setValue,
    } = useForm<{ [s: string]: any }>()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [flagArray, setFlagArray] = useState<DataTableValue[]>([])
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const [filters, setFilters] = useState<{ [s: string]: any }>()


    const getFeatureFlagData = async (username: string) => {
        dispatch(handleLoader(true))
        try {
            const { result, error } = await getUserFeatureFlagData(username)
            if (error) {
                throw error
            }
            if (result.error) {
                throw result.error
            }
            result.flags.forEach((flag: any) => {
                setValue(flag.key, flag.enabled)
            });
            setFlagArray(result.flags)
            dispatch(handleLoader(false))
        } catch (error) {
            dispatch(handleLoader(false))
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onRoleManage = async () => {
        try {
            const flagData = flagArray.reduce((acc: any, item: any) => {
                acc[item.key] = item.enabled;
                return acc;
            }, {});
            const { result, error } = await updateFeatureFlagData({ user_name: email, flags: flagData })
            if (error) {
                throw error
            }
            if (result.error) {
                throw result.error
            }
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            navigate("/admin/users")
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue('');
    };


    useEffect(() => {
        getFeatureFlagData(email)
        initFilters();
    }, [])


    return (
        <section className='user-management-section'>
            <div className='d-flex align-items-center flex-wrap mb-3'>
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center mr-3">
                            <IconField iconPosition="right" className='user-input'>
                                <InputIcon className="pi pi-search"></InputIcon>
                                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                            </IconField>
                        </div>
                        <Button className="outline-active-btn" type="button" onClick={onRoleManage}>Save</Button>
                    </div>
                </div>
            </div>
            <div className="set-permission-main flag-main">
                <div className='set-permission-wrap'>
                    <div className="set-permission-table-wrap">
                        {/* <div className='d-flex justify-content-between permission-table-head'>
                            <h6>Flag Name</h6>
                            <h6>Flag Permission</h6>
                        </div> */}
                        <div className="set-permission-table group-permission-table">
                            <FeatureFlagDataTable filters={filters} flagArray={flagArray} setFlagArray={setFlagArray} />
                        </div>
                    </div>
                </div>
                <p className="mb-0 fix-note"><strong>NOTE:</strong> The changes you made in the settings will be reflected after you login again.</p>
            </div>
        </section>
    )
}

export default FlagInfo